import { bl_fi_slsodr_to_slsinv_consol_run_hdr_RowClass } from "../../dbschema/bl_fi_slsodr_to_slsinv_consol_run_hdr.model";
import { BaseContainerModel } from "../base-container.model";

export class SOConsolidationRunModel extends BaseContainerModel {
  bl_fi_slsodr_to_slsinv_consol_run_hdr: bl_fi_slsodr_to_slsinv_consol_run_hdr_RowClass =
    new bl_fi_slsodr_to_slsinv_consol_run_hdr_RowClass();
}
